import {
  getCardDesign,
  batchSaveDesigns,
} from "@/services/api";

/**
 * Product Management Mixin
 * Handles product and order related operations
 */
export default {
  methods: {
    async afterProductsLoad(jobs) {
      this.numberOfProducts = jobs.length;
      this.$refs.loader.hide();
    },

    async onProductClick({ job, index, prompt, scroll }) {
      if (prompt && this.enableSave) {
        return this.$refs.promptModal.open({ job, index, scroll });
      }
      this.selectProduct({ job, index, scroll });
    },

    async selectProduct({ job, index, scroll }) {
      this.$refs.products.selectedJob(index, scroll);
      this.$refs.toolbar.showTemplatesPanel = false;
      window?.activeCanvas?.discardActiveObject();
      this.showFrontSide();
      this.jobID = job.id;

      let data = await getCardDesign(job.id);

      await window.frontCanvas?.dispose();
      await window.helperCanvas?.dispose();
      if (window.backCanvas?.upperCanvasEl) {
        await window.backCanvas.dispose();
      }

      await this.initializeCanvases(true, data);

      if (data.front) {
        await window.frontCanvas.loadFromJSON(data.front);
        window.frontCanvas.renderAll();
      }

      if (data.back) {
        await window.backCanvas.loadFromJSON(data.back);
        window.backCanvas.renderAll();
      }

      const design = window.frontCanvas.toDataURL({
        format: "png",
        multiplier: 5,
        enableRetinaScaling: true,
      });
      this.$forceUpdate();
    },

    onCopyDesign(job, selectedJob, index) {
      this.onProductClick({ job, index, prompt: false });
      this.jobID = selectedJob.id;
    },

    async pasteToAllAtOnce(design_ids = []) {
      this.$refs.loader.show(this.$t("savingDesign"));

      try {
        await batchSaveDesigns(design_ids, this.jobID);

        setTimeout(() => {
          this.$refs.loader.hide();
        }, 2000);

        const design = window.frontCanvas.toDataURL({
          format: "png",
          multiplier: 5,
          enableRetinaScaling: true,
        });
        this.$forceUpdate();
        location.reload();
      } catch (error) {
        this.$refs.toast.show({
          message: this.$t("saveJobFailedMessage"),
          type: "error",
        });
      }
    },

    async pasteSingle(design_id) {
      this.$refs.loader.show(this.$t("savingDesign"));

      try {
        await batchSaveDesigns([ design_id ], this.jobID);

        const newDesign = await getCardDesign(design_id);

        if (this.isEditOrder) {
          const design = window.frontCanvas.toDataURL({
            format: "png",
            multiplier: 5,
            enableRetinaScaling: true,
          });
          this.$refs.products.updateDesign(design);

          await window.frontCanvas.loadFromJSON(newDesign.front);
          if (newDesign.back && window.backCanvas) {
            await window.backCanvas.loadFromJSON(newDesign.back);
          }

          window.frontCanvas.renderAll();
          if (window.backCanvas) {
            window.backCanvas.renderAll();
          }

          this.$refs.products.selectNextProduct();
        }

        setTimeout(() => {
          this.$refs.loader.hide();
        }, 1000);

        setTimeout(() => {
          this.saveDesign(false);
        }, 1500);
      } catch (error) {
        this.$refs.toast.show({
          message: this.$t("saveJobFailedMessage"),
          type: "error",
        });
      }
    },

    async onPromptModalClosed({ success, state }) {
      if (success) {
        await this.saveDesign();
      }
      this.selectProduct(state);
    },

    async orderSubmitted() {
      this.isSubmitted = true;
      this.$refs.loader.show(
        this.$t("designSubmitted") + "<br><br>" + this.$t("designSubmittedP"),
        true
      );

      setTimeout(() => {
        this.$refs.loader.hide(true);
      }, 5000);
    },
  },
};
